const gallery = document.querySelector('.gallery')

let urlParams;
(window.onpopstate = function () {
    var match,
        pl     = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        query  = window.location.search.substring(1);

    urlParams = {};
    while (match = search.exec(query))
        urlParams[decode(match[1])] = decode(match[2]);
})();

gallery.addEventListener('click', function(e){
    e.preventDefault()
    const url = window.location.href
    const last = url.split('/').filter( item => Boolean(item)).pop()

    const regex = /[?&]lang=/;
    const found = last.match(regex);
    console.warn(Boolean(found))
    if(Boolean(found)) {
        console.log(urlParams.lang)

        if(urlParams.lang === 'fr') {
            console.log('/gallerie?lang=fr')
            window.location= '/gallerie?lang=fr'
        } else {
            console.log('/gallery')
            window.location= '/gallery'
        }
    } else {
        window.location= '/gallery'
    }
})